
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-india-upsc-prelims-mock-test",
      function () {
        return require("private-next-pages/all-india-upsc-prelims-mock-test/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all-india-upsc-prelims-mock-test"])
      });
    }
  